import base from '@mlib/js/base/base.js'

import wxsdk from './child/wx.js'
import wxworksdk from './child/wxwork.js'
import ddsdk from './child/dd.js'
import xgjsdk from './child/xgj.js'

import q from './queue/queue.js'

var sdk = {},
    sdkmap = {
        wx: wxsdk,
        wxxcx: wxsdk,
        wxwork: wxworksdk,
        dd: ddsdk,
        xgj: xgjsdk,
        browser: wxsdk
    }

sdk = sdkmap[base.env]

sdk.q = q

export default { sdk, sdkmap }




